var routesInfo = [
    {
        name: '安全设置',
        href: '/securitySetting',
        children: [
          {
            name: '登陆密码',
            href: '/updatePassword'
          },
          {
            name: '绑定手机',
            href: '/bindingCellPhone'
          },
          {
            name: '密保问题',
            href: '/setInsurance'
          }
        ]
      }
  ];
  export default routesInfo;
  


// WEBPACK FOOTER //
// ./src/router/routesInfo.js